/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Flex, Button, Checkbox, FormLabel } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { _SCHEDULED_TYPES, SERVICE_SCHEDULES_DEFAULT } from "../constants";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { useLookupCashCenterRoutes } from "../../../services/lookups-mutations";
import { useLookupServiceTypes } from "services/lookups-queries";
import { Calendar } from "@repo/ui";
import { MultiSelectDatePicker } from "components/forms/multi-date-picker";

const weekdays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const formValidationRules = {
  scheduleType: { required: "Please Select Schedule Type" },
  routeNo: { required: "Please Enter Route Number" },
  serviceType: { required: "Please Select Service Type" },
  jobType: { required: "Please Select Job Type" },
};

export default function ScheduledService({
  serviceSchedules,
  onNextStep,
  onPrevStep,
  cashCenterId,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const { data: serviceTypes } = useLookupServiceTypes();
  const {
    handleSubmit,
    getValues,
    watch,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...SERVICE_SCHEDULES_DEFAULT,
      schedules: serviceSchedules,
    },
  });
  const generalFieldProps = { control, errors };

  const { fields: schedulesFields, remove: schedulesFieldsRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "schedules",
    });

  const { data: routesListRes } = useLookupCashCenterRoutes(cashCenterId);

  const submitInfo = (data) => {
    const _schedules = [...schedulesFields];
    const newSchedule = {
      scheduleType: data.scheduleType,
      routeNo: data.routeNo,
      serviceType: data.serviceType,
      jobType: data.jobType,
      weekDays: data.weekDays,
      monthDates: data.monthDates,
    };
    if (currentEditing !== null) {
      _schedules[currentEditing] = newSchedule;
      setCurrentEditing(null);
    } else {
      _schedules.push(newSchedule);
    }
    reset({
      ...SERVICE_SCHEDULES_DEFAULT,
      schedules: [..._schedules],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Schedule"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,
              schedules: [...schedulesFields],
              monthlyDates: dataItem?.monthDates?.map((d) => {
                const date = new Date();
                date.setDate(Number(d));
                return date;
              }),
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Schedule"
          cursor="pointer"
          onClick={() => {
            schedulesFieldsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...SERVICE_SCHEDULES_DEFAULT,
      schedules: [...schedulesFields],
    });
    setCurrentEditing(null);
  };

  const jobTypes = useMemo(() => {
    const _serviceType = watch("serviceType");
    if (_serviceType) {
      const currentServiceType = serviceTypes?.data.find(
        (elm) => elm.description === _serviceType,
      );
      if (currentServiceType) {
        return currentServiceType.jobTypes.map((elm) => ({
          label: elm.description,
          value: elm.description,
        }));
      }
    }
    return [];
  }, [watch("serviceType")]);

  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button type="button" onClick={() => onPrevStep(schedulesFields)}>
              Back
            </Button>
            <Button type="submit" onClick={() => onNextStep(schedulesFields)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Schedule Type"
        name="scheduleType"
        data={_SCHEDULED_TYPES}
        placeholder="Select Schedule Type"
        rules={formValidationRules.scheduleType}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Service Type"
        name="serviceType"
        data={
          serviceTypes?.data.map((elm) => ({
            value: elm.description,
            label: elm.description,
          })) || []
        }
        placeholder="Select Service Type"
        dropdownProps={{ filterable: true }}
        rules={formValidationRules.serviceType}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Job Type"
        name="jobType"
        data={jobTypes}
        placeholder="Select Job Type"
        rules={formValidationRules.jobType}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Route No."
        name="routeNo"
        data={
          routesListRes?.data.map((elm) => ({
            value: elm.routeNo,
            label: `${elm.routeNo} (${elm.description})`,
          })) || []
        }
        placeholder="Select Route No."
        rules={formValidationRules.routeNo}
      />

      <div className="w-full" />

      {watch("scheduleType") === "Weekly" ? (
        <div className="flex flex-col">
          <FormLabel>Select Scheduled Days</FormLabel>
          <div className="w-full flex flex-row gap-4">
            <Checkbox
              isChecked={watch("weekDays").length === weekdays.length}
              onChange={() => {
                setValue("weekDays", [...weekdays], {
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }}
            >
              All
            </Checkbox>
            {weekdays.map((elm) => (
              <Checkbox
                key={`${elm}-name`}
                isChecked={Boolean(watch("weekDays")?.find((e) => e === elm))}
                onChange={() => {
                  const _selectedDays = [...watch("weekDays")];
                  const _existing = _selectedDays.indexOf(elm);
                  if (_existing === -1) {
                    _selectedDays.push(elm);
                  } else {
                    _selectedDays.splice(_existing, 1);
                  }
                  setValue("weekDays", [..._selectedDays], {
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }}
              >
                {elm}
              </Checkbox>
            ))}
            <Checkbox
              isChecked={false}
              onChange={() => {
                setValue("weekDays", [], {
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }}
            >
              Clear All
            </Checkbox>
          </div>
        </div>
      ) : null}
      {watch("scheduleType") === "Monthly" ? (
        <div className="flex flex-col w-[24%]">
          <FormLabel>Select Scheduled Dates</FormLabel>
          <MultiSelectDatePicker
            dates={watch("monthlyDates") || []}
            placeholder="Pick Scheduled Dates"
            setDates={(e) => {
              setValue(
                "monthDates",
                e?.map((d) => String(d.getDate())),
                {
                  shouldDirty: true,
                  shouldTouch: true,
                },
              );
              setValue("monthlyDates", e, {
                shouldDirty: true,
                shouldTouch: true,
              });
            }}
          />
        </div>
      ) : null}

      <Grid data={schedulesFields} style={{ width: "100%" }}>
        <GridColumn title="Scheduled Type" field="scheduleType" />
        <GridColumn title="Service Type" field="serviceType" />
        <GridColumn title="Job Type" field="jobType" />
        <GridColumn title="Route No" field="routeNo" />
        <GridColumn
          title="Week Days"
          cell={({ dataItem }) => <td>{dataItem.weekDays?.join(", ")}</td>}
        />
        <GridColumn
          title="Month Date"
          field="jobType"
          cell={({ dataItem }) => <td>{dataItem.monthDates?.join(", ")}</td>}
        />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update Schedule" : "Add Schedule"}
        </Button>
      </div>
    </form>
  );
}
